/*****************************************************************
 *  Animation Events
 * ***************************************************************/

export const INIT_ANIMATION = "INIT_ANIMATION"
export const INIT_METAS = "INIT_METAS"
export const SCENE_LOADED = "SCENE_LOADED"
export const ACTUAL_KEYFRAME = "ACTUAL_KEYFRAME"
export const CAMERA_AUTO = "CAMERA_AUTOMODE"
export const SET_KEYFRAME_TO_END = "SET_KEYFRAME_TO_END"
export const SET_KEYFRAME_TO_BEGIN = "SET_KEYFRAME_TO_BEGIN"
export const SET_KEYFRAME_TO = "SET_KEYFRAME_TO"
export const TOOGLE_ANIMATION_VISIBLE = "TOOGLE_ANIMATION_VISIBLE"
